
const product_type_donation_tag = "donation_product"
const fastShippingGroupArray = [
  {
    "title": "Alternativegroup-0",
    "min_day": "0",
    "max_day": "1"
  }
]
const deliveryGroupArray = [
  {
    "title": "group-0",
    "min_day": "0",
    "max_day": "1"
  },
  {
    "title": "group-1",
    "min_day": "0",
    "max_day": "2"
  },
  {
    "title": "group-2",
    "min_day": "3",
    "max_day": "5"
  },
  {
    "title": "group-3",
    "min_day": "6",
    "max_day": "10"
  },
  {
    "title": "group-4",
    "min_day": "11",
    "max_day": "15"
  },
  {
    "title": "group-5",
    "min_day": "16",
    "max_day": "20"
  },
  {
    "title": "group-6",
    "min_day": "21",
    "max_day": "25"
  },
  {
    "title": "group-7",
    "min_day": "26",
    "max_day": "30"
  },
  {
    "title": "group-8",
    "min_day": "31",
    "max_day": "35"
  },
  {
    "title": "group-9",
    "min_day": "36",
    "max_day": "40"
  },
  {
    "title": "group-10",
    "min_day": "41",
    "max_day": "45"
  },
  {
    "title": "group-11",
    "min_day": "46",
    "max_day": "50"
  },
  {
    "title": "group-12",
    "min_day": "51",
    "max_day": "55"
  },
  {
    "title": "group-13",
    "min_day": "56",
    "max_day": "60"
  },
  {
    "title": "group-14",
    "min_day": "61",
    "max_day": "65"
  },
  {
    "title": "group-15",
    "min_day": "60",
    "max_day": "88"
  },
  {
    "title": "group-16",
    "min_day": "80",
    "max_day": "92"
  },
]
const expectedShipArray = [
  {
    "title": "expectedship-1",
    "day": "1"
  },
  {
    "title": "expectedship-2",
    "day": "2"
  },
  {
    "title": "expectedship-3",
    "day": "3"
  },
  {
    "title": "expectedship-4",
    "day": "4"
  },
  {
    "title": "expectedship-5",
    "day": "5"
  },
  {
    "title": "expectedship-6",
    "day": "6"
  },
  {
    "title": "expectedship-7",
    "day": "7"
  },
  {
    "title": "expectedship-9",
    "day": "9"
  },
  {
    "title": "expectedship-10",
    "day": "10"
  },
  {
    "title": "expectedship-14",
    "day": "14"
  },
  {
    "title": "expectedship-15",
    "day": "15"
  },
  {
    "title": "expectedship-17",
    "day": "17"
  },
  {
    "title": "expectedship-18",
    "day": "18"
  },
  {
    "title": "expectedship-20",
    "day": "20"
  },
  {
    "title": "expectedship-21",
    "day": "21"
  },
  {
    "title": "expectedship-24",
    "day": "24"
  },
  {
    "title": "expectedship-25",
    "day": "25"
  },
  {
    "title": "expectedship-30",
    "day": "30"
  },
  {
    "title": "expectedship-35",
    "day": "35"
  },
  {
    "title": "expectedship-40",
    "day": "40"
  },
  {
    "title": "expectedship-50",
    "day": "50"
  },
];
const getDateFromNow = (day) => {
  let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let today = new Date();
  let newDate = countWeekendDays(today, day);
  if (newDate.getDay() == 6 || newDate.getDay() == 0) {
    newDate = addDays(newDate, 2);
  }
  return `${days[newDate.getDay()]}, ${months[newDate.getMonth()]} ${newDate.getDate()}`;
}
const countWeekendDays = (d0, days) => {
  for (let i = 0; i < days; i++) {
    d0 = addDays(d0, 1);
    if (d0.getDay() == 6) {
      d0 = addDays(d0, 2);
    }
    if (d0.getDay() == 0) {
      d0 = addDays(d0, 1);
    }
  }
  return d0;
}
const addDays = (myDay, no) => {
  return new Date(
    myDay.getFullYear(),
    myDay.getMonth(),
    myDay.getDate() + parseInt(no)
  )
}

/* Do not change this to normal export. This file is used in client and server side */
module.exports.setEstimatedShip = (item,lead_time) => {
  let tags = item?.product?.tags;
  if (!tags) {
    console.error("Tags not found", item);
    return
  }
  if (tags.includes(product_type_donation_tag)) {
    return;
  }
  let findShipDays = expectedShipArray.find(group => {
    return tags.includes(group.title);
  })
  if (!findShipDays) {
    return false;
  }
  let shipDays = parseInt(findShipDays?.day);
  if(lead_time){
    shipDays = shipDays + lead_time
  }
  shipDays = getDateFromNow(shipDays);
  return {
    "key": "_expected-ship",
    "value": shipDays
  }
}

/* Do not change this to normal export. This file is used in client and server side */
module.exports.setGroupShipDate = (item, minMax, lead_time,fastShippingVariant = {}) => {
  let tags = item?.product?.tags ? item?.product?.tags : item?.tags;
  let isFastShippingVariant = item?.local_item?.value === "Local" || fastShippingVariant?.fastShippingVariant === true;
  if(fastShippingVariant?.fastShippingVariant) {
    tags = fastShippingVariant?.tags;
  }

  if (!tags) {
    console.error("Tags not found", item);
    return false;
  }
  if (tags.includes(product_type_donation_tag)) {
    return;
  }
 
  const checkGroupTag=tags.some(tag=>tag.startsWith('group'));
  if(!checkGroupTag && !isFastShippingVariant){
    return false;
  }

  let findGroup;
  // Check if the variant is fast shipping or not and Estimate delivery dates
  if(isFastShippingVariant){
    findGroup = fastShippingGroupArray.find(group => {
      return tags.includes(group.title);
    })
    if(!findGroup){
      findGroup = deliveryGroupArray.find(group => {
        return tags.includes(group.title);
      })
    }
  }
  else{
    findGroup = deliveryGroupArray.find(group => {
      return tags.includes(group.title);
    })
  }
  if (!findGroup) {
    return false;
  }
  let carrierMin;
  let carrierMax;
  /* Default took standard shipping min and max days. If min and max are not passed in params. */
  if (!carrierMin) {
    carrierMin = "3";
  }
  if (!carrierMax) {
    carrierMax = "4";
  }
  if (minMax && minMax.min) {
    carrierMin = minMax.min;
  }
  if (minMax && minMax.max) {
    carrierMax = minMax.max;
  }
  if (!carrierMin || !carrierMax) {
    return;
  }
  carrierMin = parseInt(carrierMin);
  carrierMax = parseInt(carrierMax);

  /* minMax of line item and minMax of carrier addition */
  let maxDate;
  let minDate;
  maxDate = parseInt(findGroup.max_day);
  minDate = parseInt(findGroup.min_day);
  minDate = minDate + carrierMin;
  if (isNaN(carrierMax)) {
    maxDate = maxDate + carrierMin;
  }
  else {
    maxDate = maxDate + carrierMax;
  }
  if(lead_time){
    minDate = minDate + lead_time;
    maxDate = maxDate + lead_time;
  }
  minDate = getDateFromNow(minDate);
  maxDate = getDateFromNow(maxDate);
  let deliveryText;
  if (minDate == maxDate) {
    deliveryText = `Delivery by ${minDate}`;
  }
  else {
    deliveryText = `Estimated delivery ${minDate} - ${maxDate}`;
  }
  return {
    property: { key: "_estimate", value: deliveryText }, shopify: findGroup
  };
}